import React from 'react';
import { Picture } from '@ui';
import { userNoAvatar, starYellow } from '@images';
import useWindowSize from '@customHooks/useWindowSize';
import './ReviewCard.scss';

export interface ReviewCardProps {
  id: string | number;
  fio: string;
  rating: number;
  date: string;
  text: string;
  peopleItem?: {
    attachmentsItem?: {
      cacheItem?: Array<{
        filePath?: string | null;
      }> | null;
    } | null;
  } | null;
}

const ReviewCard: React.FC<ReviewCardProps> = ({
  fio,
  rating,
  date,
  text,
  peopleItem
}) => {
  const { isDesktop } = useWindowSize();

  const addText = (): string => {
    const limit = isDesktop ? 150 : 80;

    if (text.length > limit) {
      return `${text.slice(0, limit)}...`;
    }
    return text;
  };

  return (
    <div className='review-card'>
      <div className='review-card__header'>
        <Picture
          icon={
            peopleItem?.attachmentsItem?.cacheItem?.[0]?.filePath ||
            userNoAvatar
          }
          className='review-card__icon'
        />
        <div className='review-card__name-wrapper'>
          <div className='review-card__name'>{fio}</div>
        </div>
      </div>

      <div className='review-card__rating-date'>
        <div className='review-card__rating'>
          <Picture
            icon={starYellow}
            width={14}
            height={14}
            className='review-card__star-icon'
          />
          <span>{rating}</span>
        </div>
        <div className='review-card__date'>{date}</div>
      </div>

      <div className='review-card__text'>{addText()}</div>
    </div>
  );
};

export default ReviewCard;
